import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';
import ViewHOC from '../hoc/view';

const propTypes = {
	intl: PropTypes.func,
	filters: PropTypes.array,
	choose: PropTypes.func
};

const SwitchControlMulti = ({
	intl,
	filters,
	choose
}) => {
	const shouldShowAdditionalSign = (filters.filter(entity => entity.active)).length > 1;
	return (
		<div className="switch-control switch-control-multi">
			{ filters && filters.map(filter => (
				<button
					key={filter.name}
					onClick={e => {
						e.preventDefault();
						choose(filter.name);}
					}
					className={cn(
						'ui-btn ui-btn-secondary',
						filter.active && 'active',
						shouldShowAdditionalSign && 'active--remove-sign',
						filter.className && filter.className
					)}>
					{ intl(filter.placeholder) }
				</button>
			)) }
		</div>
	);
};

SwitchControlMulti.propTypes = propTypes;
export default ViewHOC(SwitchControlMulti);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/switch-control/multi/main.js